var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useContext, useEffect, useState } from 'react';
import useGetSurveyContent from '../../hooks/useGetSurveyContent';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { Box } from 'pcln-design-system';
import { CaresSurvey } from '@pcln/feedback-survey';
import usePostSurveyContent from '../../hooks/usePostSurveyContent';
import Loading from '../Loading';
const PennyCaresSurvey = ({
  onClose,
  offerNumber
}) => {
  const {
    submitChatMessagesPayload
  } = useContext(ChatbotDataContext);
  const [variables, setVariables] = useState({
    encodedId: '',
    answers: undefined
  });
  const {
    details,
    isDetailsRetrieved,
    encodedId,
    loading
  } = useGetSurveyContent(submitChatMessagesPayload);
  const {
    isAnswersSent
  } = usePostSurveyContent(variables);
  useEffect(() => {
    if (isAnswersSent) {
      const offerProcessed = localStorage.getItem('PennyCaresSurveyDict');
      if (offerProcessed && typeof offerProcessed === 'string') {
        try {
          const parsedOfferProcessed = JSON.parse(offerProcessed);
          parsedOfferProcessed.push(offerNumber);
          localStorage.setItem('PennyCaresSurveyDict', JSON.stringify(parsedOfferProcessed));
        } catch (e) {
          localStorage.setItem('PennyCaresSurveyDict', JSON.stringify([offerNumber]));
        }
      } else {
        localStorage.setItem('PennyCaresSurveyDict', JSON.stringify([offerNumber]));
      }
    }
  }, [isAnswersSent]);
  if (loading) {
    return React.createElement(Loading, null);
  }
  if (!isDetailsRetrieved && !loading) {
    onClose();
    return null;
  }
  const processScoresSubmitted = scoresSubmitted => {
    const answers = [];
    const questionIds = Object.keys(scoresSubmitted);
    questionIds.forEach(id => {
      answers.push({
        id,
        answer: {
          value: scoresSubmitted[id].value,
          type: scoresSubmitted[id].type === 'rating' ? 'numeric' : 'text'
        }
      });
    });
    return answers;
  };
  function handleSurveySubmit(scoresSubmitted) {
    return __awaiter(this, void 0, void 0, function* () {
      const answersForSubmission = processScoresSubmitted(scoresSubmitted);
      setVariables({
        encodedId,
        answers: answersForSubmission
      });
    });
  }
  return React.createElement(Box, {
    p: 4
  }, React.createElement(CaresSurvey, {
    surveyDetails: details,
    submitFunction: handleSurveySubmit
  }));
};
export default PennyCaresSurvey;